$.ready(function() {
	let fancy = {};
	let loader = window.loader;
	let intervals = [];
	
	fancy.base = $.div().addClass("fancy base").prependTo(loader);
	fancy.guy = $.div().addClass("wolf main").prependTo(fancy.base);
	fancy.guyLeft = $.div().addClass("wolf left").prependTo(fancy.base);
	fancy.guyRight = $.div().addClass("wolf right").prependTo(fancy.base);
	
	fancy.backdrop = $.div("backdrop").prependTo(loader);
	fancy.face = $.div().addClass("face").appendTo(fancy.guy);
	fancy.blink = $.div().addClass("blink").appendTo(fancy.guy);
	fancy.smile = $.div().addClass("smile").appendTo(fancy.guy);
	fancy.breath = $.div().addClass("breath").appendTo(fancy.guy);
	
	fancy.logo = $.div().addClass("logo").appendTo(fancy.base);
	fancy.info = $.div().addClass("action").appendTo(fancy.base);
	fancy.info = $.div().addClass("xtra").appendTo(fancy.base);
	fancy.konami = $.div().addClass("konami").appendTo(fancy.base);
	fancy.legal = $.div().addClass("legal").appendTo(fancy.base);
	
	intervals.push(setInterval(function() {
		fancy.blink.addClass("wink");
		
		setTimeout(function() {
			fancy.blink.removeClass("wink");
		}, 600);
	}, 10000));
	
	intervals.push(setInterval(function() {
		fancy.breath.addClass("show");
		
		setTimeout(function() {
			fancy.breath.removeClass("show");
		}, 1100);
	}, 5000));
	
	game.on("ready", function() {
		for (let index = 0; index < intervals.length; index++) {
			clearInterval(intervals[index]);
		}
	});
	
	game.on("scale", function(e) {
		e.detail.resize({ width: 1920, height: 1080, font: 24 }, fancy.base);
	});
});



/** WEBPACK FOOTER **
 ** ./public-src/js/fancy_belly.js
 **/